import React from 'react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import './Pricing.css';

const Pricing = () => {
  const plans = [
    {
      title: "Self Paced",
      subtitle: "Learn at your own pace",
      price: "₹5,999",
      popular: false,
      features: [
        { name: "Recorded Sessions", included: true },
        { name: "Hands-on Projects", included: true },
        { name: "Certifications", included: true },
        { name: "Doubt Clear Sessions", included: true },
        { name: "Live Sessions", included: false },
        { name: "Mentor Guidance", included: false },
        { name: "Placement Support", included: false },
        { name: "1:1 Mentoring", included: false }
      ]
    },
    {
      title: "Mentor Led",
      subtitle: "Guided learning with mentor support",
      price: "₹9,999",
      popular: true,
      features: [
        { name: "Recorded Sessions", included: true },
        { name: "Hands-on Projects", included: true },
        { name: "Certifications", included: true },
        { name: "Doubt Clear Sessions", included: true },
        { name: "Live Sessions", included: true },
        { name: "Mentor Guidance", included: true },
        { name: "Placement Support", included: false },
        { name: "1:1 Mentoring", included: false }
      ]
    },
    {
      title: "Professional",
      subtitle: "Be placement ready",
      price: "₹14,999",
      popular: false,
      features: [
        { name: "Recorded Sessions", included: true },
        { name: "Hands-on Projects", included: true },
        { name: "Certifications", included: true },
        { name: "Doubt Clear Sessions", included: true },
        { name: "Live Sessions", included: true },
        { name: "Mentor Guidance", included: true },
        { name: "100% Placement Support", included: true },
        { name: "1:1 Mentoring", included: true }
      ]
    }
  ];

  return (
    <section className="pricing-section-container">
      <div className="pricing-container-inner">
        <h2 className="pricing-title">Flexible Learning Plans</h2>
        <p className="pricing-subtitle">Choose the track that fits your career goals</p>

        <div className="pricing-grid-layout">
          {plans.map((plan, index) => (
            <div className={`pricing-card-item ${plan.popular ? 'popular-card' : ''}`} key={index}>
              {plan.popular && <div className="popular-badge">Recommended</div>}
              <div className="pricing-card-header">
                <h3>{plan.title}</h3>
                <p>{plan.subtitle}</p>
              </div>
              <div className="pricing-card-body">
                <div className="pricing-card-price">
                  {plan.price}
                </div>
                <ul className="pricing-card-features">
                  {plan.features.map((feature, i) => (
                    <li key={i} className={feature.included ? 'included' : 'excluded'}>
                      <span className="feature-icon">
                        {feature.included ?
                          <FaCheckCircle className="icon-tick" />
                          :
                          <FaTimesCircle className="icon-cross" />
                        }
                      </span>
                      {feature.name}
                    </li>
                  ))}
                </ul>
                <button 
                  className={`pricing-enroll-btn ${plan.popular ? 'btn-popular' : ''}`}
                  onClick={() => {
                    const element = document.querySelector('.programs');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  Enroll Now
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
